// @ts-nocheck
import React, { useState } from "react";
import useAccount, { getCurAccount } from "classes/Accounts/hooks/useAccount";
import { QuerySelect } from "components/Inputs/CustomAsyncSelect/CustomAsyncSelect";
import genRequest from "includes/request";
import { useQueryClient } from "react-query";
import "./CompanyChanger.css";
import ErrorsCont from "components/ErrorsCont/ErrorsCont";
import Button from "components/Button/Button";
import { t } from "i18next";

function CompanyChanger(props) {

	const { account, setAccount } = useAccount();
	const [error, setError] = useState(false);
	const [curValue, setCurValue] = useState(account.companyId);
	const QCL = useQueryClient();

	const fetchAdminsOfCompany = (compId) => genRequest("employees/admins/company/" + compId);

	function changeCompany(comp) {
		let original = getCurAccount(true);
		let companyId = comp.value;
		setError(false);
		if (companyId === original.companyId)
			return (resetOriginal());
		let prom = fetchAdminsOfCompany(companyId).then((resp) => {
			if (resp?.length) {
				// `admins/company/:id` answers `id`: alias it to `employeeId` once, here
				let EloAdmins = resp.filter(a => a.role === "EloAdmin").map(a => ({ ...a, employeeId: a.employeeId ?? a.id }));
				if (EloAdmins?.length) {
					original.tempValues = EloAdmins[0];
					setAccount(original);
					setCurValue(companyId);
					QCL.resetQueries(["Template"]);
					return (true);
				}
			}
			setError("Aucun GodAdmin n'est disponible pour la compagnie " + (comp.label ? "\"" + comp.label + "\"" : "sélectionnée") + ", veuillez en créer un");
			setCurValue(companyId);
			return (false);
		});
		return (prom);
	}

	const resetOriginal = () => {
		let original = getCurAccount(true);
		original.tempValues = false;
		original.isTemp = false;
		setCurValue(original.companyId);
		setAccount(original);
		QCL.resetQueries(["Template"]);
		return (true);
	};

	return (
		<div className={"CompanyChanger" + (props.className ? " " + props.className : "")}>
			{
				account.isTemp && props.resetBtn !== false &&
				<Button title="Revenir sur le réseau OnlyAll initialement relié au compte lors de la connexion" className="btn-bg btn-h-primary mb-2" onClick={resetOriginal}>OnlyAll {t('Settings.DEFAULT')}</Button>
			}
			<QuerySelect
				classNamePrefix="dropdown"
				initialValue={[{ value: curValue }]}
				onChange={changeCompany}
				closeMenuOnSelect={true}
				queryKey={["Companies"]}
				queryFn={() => genRequest("companies")}
				menuPlacement={props.menuPlacement}
				treat={(item) => {
					return ({
						value: item.id,
						label: item.name
					});
				}}
			/>
			<ErrorsCont className="mt-2 font-bold" errors={error} />
		</div>
	);
}

export default CompanyChanger;
